import React from "react";
import { Loader } from "components/commons";
import styles from "./shift-details-stock-inventory.module.scss";
import ShiftDetailsFuelSales from "./shift-details-stock-inventory-fuel-sales";
import ShiftDetailsAllFuelProducts from "./shift-details-stock-inventory-all-fuel-product";
import ShiftDetailsDipstick from "./shift-details-stock-inventory-dipstick";
import ShiftDetailsFuelDeliveries from "./shift-details-stock-inventory-fuel-deliveries";
import ShiftDetailsFuelVariance from "./shift-details-stock-inventory-fuel-variance";

const ShiftRecordsDetailsStockInventoryWetModule = (props) => {
  const {
    loadingShift,
    shift,
    form,
    endDidNotPerformDipStick,
    setEndDidNotPerformDipStick,
    progress,
    pageMode,
    isShiftEndedCompletely,
    remarksUgt,
    setRemarksUgt,
    recentShiftDetails,
  } = props;

  return (
    <>
      <Loader open={loadingShift} />
      {shift && !loadingShift && (
        <div className={styles.container}>
          <ShiftDetailsFuelSales
            isShiftEndedCompletely={isShiftEndedCompletely}
            shift={shift}
            form={form}
            recentShiftDetails={recentShiftDetails}
          />
          <ShiftDetailsAllFuelProducts
            isShiftEndedCompletely={isShiftEndedCompletely}
            shift={shift}
          />
          <ShiftDetailsDipstick
            shift={shift}
            progress={progress}
            pageMode={pageMode}
            form={form}
            endDidNotPerformDipStick={endDidNotPerformDipStick}
            setEndDidNotPerformDipStick={setEndDidNotPerformDipStick}
          />
          <ShiftDetailsFuelDeliveries shift={shift} />
          <ShiftDetailsFuelVariance
            shift={shift}
            progress={progress}
            form={form}
            pageMode={pageMode}
            remarksUgt={remarksUgt}
            setRemarksUgt={setRemarksUgt}
          />
        </div>
      )}
    </>
  );
};

export default ShiftRecordsDetailsStockInventoryWetModule;
